import { render, staticRenderFns } from "./CreateGiftingAddressForm.vue?vue&type=template&id=6cc9aea9&"
import script from "./CreateGiftingAddressForm.vue?vue&type=script&lang=js&"
export * from "./CreateGiftingAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports